import styled from 'styled-components';

import MoreVert from '../../assets/images/more_vert.svg';

export const Wrapper = styled.div<{ isActive: boolean }>`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  margin-top: -5px;
  margin-bottom: -5px;
  background-color: ${({ isActive }) => (isActive ? '#373c43' : 'transparent')};

  &:hover {
    background-color: #373c43;
  }

  transition: background-color 0.2s ease-in-out;
`;

export const Background = styled.div<{ isModalOpened: boolean }>`
  z-index: 1;
  pointer-events: ${({ isModalOpened }) => (isModalOpened ? 'auto' : 'none')};
  ${({ isModalOpened }) =>
    isModalOpened ? { position: 'absolute', left: 0, right: 0, bottom: 0, top: 0 } : null};
`;

export const Button = styled.div`
  cursor: pointer;
  mask-image: url('${MoreVert}');
  mask-position: center;
  background-color: var(--colorBlueGray600);
  height: 20px;
  width: 20px;
`;

export const Modal = styled.div`
  position: absolute;
  top: 40px;
  right: 10px;
  z-index: 9;
  background-color: var(--colorWhite);
  padding: 24px;
  border-radius: 8px;
  min-width: 192px;

  box-shadow: 0px 0px 15px -7px rgba(0, 0, 0, 0.32), 0px 0px 46px 8px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.24);
`;

export const Item = styled.a<{ isDelete: boolean; disabled?: boolean }>`
  font-size: 12px;
  font-weight: 600;
  color: ${({ isDelete }) => (isDelete ? 'var(--colorUIRed)' : 'var(--colorBlueGray1200)')};
  margin-bottom: 16px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  display: block;
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  &:last-child {
    margin-bottom: 0;
  }
`;

export const StorybookWrapper = styled.div`
  margin-left: 200px;
`;
